import { EventListSlot, EventListSubmission } from './models';

/**
 * Mirrors the API's EventService.findListSubmission (event.service.ts:767): slotId wins when both
 * sides have one, because a slot's label is free text an organiser can rename at any time. Label
 * remains the fallback for registrations made before slotId existed.
 */
export function findSubmissionForSlot(
    submissions: EventListSubmission[] | undefined,
    slot: EventListSlot
): EventListSubmission | undefined {
    const all = submissions ?? [];
    if (slot.id != null) {
        const bySlotId = all.find((s) => s.slotId === slot.id);
        if (bySlotId) {
            return bySlotId;
        }
    }
    return all.find((s) => s.slotLabel === slot.label);
}

/** Optional slots are shown on the page but never counted toward what a registrant owes. */
export function getRequiredListProgress(
    slots: EventListSlot[] | undefined,
    submissions: EventListSubmission[] | undefined
): { submitted: number; required: number } {
    const requiredSlots = (slots ?? []).filter((s) => s.required);
    // 'accepted' counts too: an organiser signing a list off must not make it look
    // unsubmitted again, which would drop the registrant's progress back.
    const submitted = requiredSlots.filter((slot) => {
        const status = findSubmissionForSlot(submissions, slot)?.status;
        return status === 'submitted' || status === 'accepted';
    }).length;
    return { submitted, required: requiredSlots.length };
}
